export default {
    server: 'https://www.hectorblejerrepresentacionesapi.com.ar',
};